import createDictionaryAccessor, { createTimeZoneAccessor }
  from '@/creditflowresearch/application/createDictionaryAccessor';
import type IIndustry from '@/creditflowresearch/domain/vo/IIndustry';
import type { IRatingAgency } from '@/creditflowresearch/domain/vo/RatingAgency/IRatingAgency';
import type {
  IDictionaryCountry,
  IDictionaryCurrency,
  IDictionaryDealStatus,
  IDictionaryRanking,
  IDictionarySizeDescription,
  IDictionaryTimeZone,
} from '@/creditflowresearch/domain/vo/IDictionary';

export interface IUseDictionariesProps {
  industriesListAll?: IIndustry[],
  dealStatuses?: IDictionaryDealStatus[],
  currencies?: IDictionaryCurrency[],
  rankings?: IDictionaryRanking[],
  timeZones?: IDictionaryTimeZone[],
  countries?: IDictionaryCountry[],
  sizeDescriptions?: IDictionarySizeDescription[],
  ratingAgencies?: IRatingAgency[],
}

const createDictionaryAccessors = ({
  industriesListAll = [],
  dealStatuses = [],
  currencies = [],
  rankings = [],
  timeZones = [],
  countries = [],
  sizeDescriptions = [],
  ratingAgencies = [],
}: IUseDictionariesProps) => ({
  industries: createDictionaryAccessor(industriesListAll),
  subindustries: createDictionaryAccessor(
    industriesListAll.flatMap((industry) => industry.subindustryList ?? []),
  ),
  dealStatuses: createDictionaryAccessor(dealStatuses),
  currencies: createDictionaryAccessor(currencies),
  rankings: createDictionaryAccessor(rankings),
  timeZones: createTimeZoneAccessor(timeZones),
  countries: createDictionaryAccessor(countries),
  sizeDescriptions: createDictionaryAccessor(sizeDescriptions),
  ratingAgencies: createDictionaryAccessor(ratingAgencies),
  ratings: createDictionaryAccessor(
    ratingAgencies.flatMap((agency) =>
      (agency.ratings ?? []).map((rating) => ({
        ...rating,
        ratingAgencyId: agency.id,
      })),
    ),
  ),
});

export default createDictionaryAccessors;
